import { cn } from '@/lib/utils';
import { ChatHeader } from './header';
import { ChatBody } from './body';
import { ChatForm } from './form';

type ChatProps = {
  title?: string;
  className?: string;
  actions?: React.ReactNode;
  onClose?: () => void;
};

const Chat = ({ title, className, actions, onClose }: ChatProps) => {
  return (
    <div
      data-testid="chat-wrapper"
      className={cn('flex flex-col gap-0 h-full bg-white rounded-xl overflow-hidden', className)}
    >
      <ChatHeader title={title} actions={actions} onClose={onClose} />
      <ChatBody />
      <ChatForm />
    </div>
  );
};

export default Chat;
